import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { withTranslation } from 'react-i18next';
import { PopupboxManager, PopupboxContainer } from 'react-popupbox';
import ModalVideo from 'react-modal-video';

import 'react-popupbox/dist/react-popupbox.css';
import 'react-modal-video/css/modal-video.min.css';

// HOC COMPONENTS
import withMediaQuery from '@/hoc/withMediaQuery';

// COMPONENTS
import { SwiperCarousel, SwiperSlide } from '@/components/Carousels/SwiperCarousel';

// STYLES
import { Container } from '../../styles';
import { Content, Thumbnail } from './styles';

function getItemsCount(length) {
  switch (length) {
    case 1:
      return 1;
    case 2:
      return 2;
    default:
      return 3;
  }
}

class Gallery extends PureComponent {
  state = {
    modalVideo: false,
    videoUrl: '',
    galleryItems: [],
  };

  componentDidMount() {
    this.formatGalleryItems();
  }

  formatGalleryItems = () => {
    const { data } = this.props;

    const galleryItems = data.map(dataItem => {
      switch (dataItem.media_type_id_fk) {
        case 2:
        case 3:
          return {
            thumbnail: dataItem.thumbnail_image,
            original: dataItem.thumbnail_image,
            embedUrl: `${dataItem.media_url}?autoplay=1`,
            url: `${dataItem.media_url}?autoplay=1`,
            type: 'video',
          };

        default:
          return {
            thumbnail: dataItem.thumbnail_image,
            original: dataItem.media_url,
            url: dataItem.media_url,
            type: 'photo',
          };
      }
    });

    this.setState({ galleryItems });
  };

  manageModalVideoState = state => {
    const videoUrl = !state ? { videoUrl: '' } : {};

    this.setState({ modalVideo: state, ...videoUrl });
  };

  handleItemClick = data => {
    if (data.type === 'photo') {
      const content = <img src={data.url} alt="detail" />;

      PopupboxManager.open({
        content,
        config: {
          titleBar: {
            enable: true,
          },
          fadeIn: true,
          fadeInSpeed: 500,
        },
      });
    } else if (data.type === 'video') {
      this.setState({ videoUrl: data.url }, () => this.manageModalVideoState(true));
    }
  };

  render() {
    const { galleryItems, modalVideo, videoUrl } = this.state;
    const { downXs } = this.props;

    const carouselOptions = {
      navigation: false,
      pagination: true,
      watchOverflow: true,
      allowTouchMove: galleryItems.length > 2 || downXs,
      breakpoints: {
        0: {
          slidesPerView: 1.06,
          centeredSlides: true,
        },
        600: {
          slidesPerView: getItemsCount(galleryItems.length),
          centeredSlides: false,
        },
      },
    };

    return (
      <div>
        <Container className="page-content page-content--no-padding gallery-wrapper">
          {/*
          <Typography className="title m-b-10" variant="h3" align="center">
            {t('appDetails.gallery.title')}
          </Typography>
          */}
          <Content>
            {!!galleryItems.length && (
              <SwiperCarousel options={carouselOptions}>
                {galleryItems.map((item, index) => {
                  return (
                    <SwiperSlide key={index}>
                      <Thumbnail onClick={() => this.handleItemClick(item)}>
                        <img src={item.thumbnail} alt="thumb" />
                        {item.embedUrl && (
                          <div className="play-fake">
                            <i className="icon-play" />
                          </div>
                        )}
                      </Thumbnail>
                    </SwiperSlide>
                  );
                })}
              </SwiperCarousel>
            )}
          </Content>
          <PopupboxContainer />
          <ModalVideo
            url={videoUrl}
            channel="custom"
            isOpen={modalVideo}
            onClose={() => this.manageModalVideoState(false)}
          />
        </Container>
      </div>
    );
  }
}

Gallery.propTypes = {
  t: PropTypes.func.isRequired,
  data: PropTypes.array.isRequired,
  downXs: PropTypes.bool.isRequired,
};

export default compose(
  withTranslation(),
  withMediaQuery({ downXs: theme => theme.breakpoints.down('xs') }),
)(Gallery);
